import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { ProjectServiceListRequestJson } from '@vmspdb/definitions';
import { ProjectMinimal } from './projects.reducer';

export const listProjects = createAction(
  '[Project/API] List Projects',
  props<{ params: Partial<ProjectServiceListRequestJson> }>(),
);

export const loadSingleProject = createAction(
  '[Project/API] Load Single Project',
  props<{ uuid: string }>(),
);

export const listProjectsFailure = createAction(
  '[Project/API] List Projects Failure',
  props<{ error: any }>(),
);

export const loadProjects = createAction(
  '[Project/API] Load Projects',
  props<{ projects: ProjectMinimal[] }>(),
);

export const addProject = createAction(
  '[Project/API] Add Project',
  props<{ project: ProjectMinimal }>(),
);

export const upsertProject = createAction(
  '[Project/API] Upsert Project',
  props<{ project: ProjectMinimal }>(),
);

export const addProjects = createAction(
  '[Project/API] Add Projects',
  props<{ projects: ProjectMinimal[] }>(),
);

export const upsertProjects = createAction(
  '[Project/API] Upsert Projects',
  props<{ projects: ProjectMinimal[] }>(),
);

export const updateProject = createAction(
  '[Project/API] Update Project',
  props<{
    project: Update<ProjectMinimal>;
  }>(),
);

export const updateProjects = createAction(
  '[Project/API] Update Projects',
  props<{
    projects: Update<ProjectMinimal>[];
  }>(),
);

export const deleteProject = createAction(
  '[Project/API] Delete Project',
  props<{ id: string }>(),
);

export const deleteProjects = createAction(
  '[Project/API] Delete Projects',
  props<{ ids: string[] }>(),
);

export const clearProjects = createAction('[Project/API] Clear Projects');
